import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { LetterBody } from '../components/LetterBody';
import { ProductReveal } from '../components/ProductReveal';
import { IncludesSection } from '../components/IncludesSection';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { FooterCTA } from '../components/FooterCTA';
import { initMetaPixel, trackPageView } from '../utils/metaPixel';
export function SalesPage() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen w-full bg-cream text-brown font-sans selection:bg-ochre/30" data-id="element-157">
      <main data-id="element-158">
        <HeroSection data-id="element-159" />
        <LetterBody data-id="element-160" />
        <ProductReveal data-id="element-161" />
        <IncludesSection data-id="element-162" />
        <PricingSection data-id="element-163" />
        <FAQSection data-id="element-164" />
        <FooterCTA data-id="element-165" />
      </main>
    </div>;
}